import type { z } from 'zod';

import { inventoryBinLocationUpdateSchema } from './inventory-bin-locations-mutation-schema';

export const inventoryBinLocationFormSchema = inventoryBinLocationUpdateSchema;

export type InventoryBinLocationFormSchema = z.infer<typeof inventoryBinLocationFormSchema>;
